<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Document</title>
</head>
<body>
    <div class="chartFilter">
        <select class="minDropDown"  #mySelect [(ngModel)]="selectedDuration"
        (change)='onDurationSelectec(mySelect.value)'>
            <option [value]="1">Day</option>
            <option [value]="2">Week</option>
            <option [value]="3">Month</option>
            <option [value]="4">Year</option>
        </select>
        <select class="minDropDown"  #mySelect [(ngModel)]="selectedMin"
        (change)='onDurationMin(mySelect.value)'>
            <option [value]="1" *ngIf="selectedDuration == '1'">5Min</option>
            <option [value]="2" *ngIf="selectedDuration == '1'">15Min</option>
            <option [value]="3" *ngIf="selectedDuration == '1'">30Min</option>
            <option [value]="4" *ngIf="selectedDuration == '1'">1Hr</option>
            <option [value]="5" *ngIf="selectedDuration != '1'">1Day</option>           
        </select>
        <button type="button" class="btn btn-success px-2 py-0" (click)="updateChart()">Load</button>    
    </div>

<div id="chartDiv"  #chart></div>
<div *ngIf="chartError == true">Data not found</div>
    
</body>
</html>
